import { Reveal, Eyebrow } from "../components/site/Reveal";
import { CTABand } from "../components/site/CTABand";
import { PROCESS_STEPS, SECTORS } from "../lib/content";

export default function Process() {
  return (
    <>
      <section className="relative overflow-hidden border-b border-slate-200">
        <div className="absolute inset-0 grid-bg" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <Reveal>
            <Eyebrow testId="process-eyebrow">How we work</Eyebrow>
            <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0A1F44] max-w-3xl leading-[1.08]">
              A clear process. <span className="text-blue-700">A supported placement.</span>
            </h1>
            <p className="mt-7 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
              From the role brief to placement check-ins, our recruitment approach keeps the hiring
              manager, candidate and host organisation connected.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="relative">
          <div className="absolute left-[27px] top-4 bottom-4 w-px bg-gradient-to-b from-blue-600/60 via-slate-200 to-transparent hidden sm:block" aria-hidden="true" />
          <div className="space-y-10">
            {PROCESS_STEPS.map((s, i) => (
              <Reveal key={s.num} delay={i * 0.1}>
                <div className="grid sm:grid-cols-[56px_1fr] gap-6 items-start" data-testid={`process-step-${s.num}`}>
                  <div className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border border-blue-600/40 bg-white font-mono text-sm text-blue-700">
                    {s.num}
                  </div>
                  <div className="rounded-2xl border border-slate-200 bg-white p-7 transition-colors duration-300 hover:border-blue-600/40">
                    <h2 className="font-display text-xl sm:text-2xl font-bold text-[#0A1F44] tracking-tight">{s.title}</h2>
                    <p className="mt-3 text-slate-600 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal className="mt-20">
          <Eyebrow testId="process-sectors-eyebrow">Sectors we recruit for</Eyebrow>
          <div className="mt-8 flex flex-wrap gap-3">
            {SECTORS.map((s) => (
              <span
                key={s}
                className="rounded-full border border-slate-300 px-5 py-2.5 text-sm text-slate-600 transition-colors duration-200 hover:border-blue-600/60 hover:text-blue-700"
              >
                {s}
              </span>
            ))}
          </div>
        </Reveal>
      </section>

      <CTABand />
    </>
  );
}
